export default {"src":"/_next/static/media/SBUX.c9f71250.svg","height":18,"width":18};